module.exports = __webpack_public_path__ + "/images/mockup_lista_general_FR.2ba4f0b.png";